import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import {IResponse, locales} from "../../interfaces/iresponse";
import {UserService} from "../../services/apiCalls/userService/user.service";
import {SuperAdminService} from "../../services/apiCalls/superAdminService/super-admin.service";
import { FormControl, FormGroup, Validators } from '@angular/forms';


export interface genderType{
  name: string,
  value: string,
  id: number
}
@Component({
  selector: 'app-enrol-riders',
  templateUrl: './enrol-riders.component.html',
  styleUrls: ['./enrol-riders.component.css']
})
export class EnrolRidersComponent implements OnInit {
  breadCrumb: any;
  public allRiders: any[] = [];
  public viewThisRider: any = null;
  public isRiderInfo = false;
  public timeKeeper: any;
  currentUser: any;
  loadingData = false;
  localGvts: Array<locales> = [];
  states: Array<IResponse> = [];
  loadingStates: boolean = false;
  submitting:boolean = false;
  onboardRiderForm = new FormGroup({
    last_name: new FormControl('', Validators.required),
    first_name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone_no: new FormControl('', Validators.required),
    dob: new FormControl('', Validators.required),
    gender: new FormControl('', Validators.required),
    marital_status: new FormControl('', Validators.required),
    state_of_origin_id: new FormControl('', Validators.required),
    lga_of_origin_id: new FormControl('', Validators.required),
    residential_address: new FormControl('', Validators.required),
    // operation_state_id: new FormControl('', Validators.required),
    // operation_lga_id: new FormControl('', Validators.required),

  })
  constructor(private utilService: UtilService,
              private userService: UserService) {
    this.currentUser = this.utilService.getAuthUser();
  }

  genders: Array<genderType> = [
    {id: 1, name: 'Select Gender', value: ''},
    {id: 2, name: 'Male', value: 'Male'},
    {id: 3, name: 'Female', value: 'Female'},
  ]

  maritalStatus: Array<genderType> = [
    {id: 1, name: 'Select marital status', value: ''},
    {id: 2, name: 'Single', value: 'Single'},
    {id: 3, name: 'Married', value: 'Married'},
    {id: 4, name: 'Divorced', value: 'Divorced'},
  ]

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Manage Riders',
      parent: 'Home',
      subLink: null
    }
    this.getRiderProfile();
    this.getLocalGvts();
    this.getAllStates();
  }


  getRiderProfile() {
    this.loadingData = true;
    this.userService.getRiderP(this.currentUser.owner_id)
      .subscribe((res: IResponse) => {
        this.allRiders = res.data;
        this.utilService.riderTable('all-riders', false);
        this.loadingData = false;
      }, error => {
        this.utilService.startDatatable('all-riders');
        this.loadingData = false;
      });
  }
  viewRider(rider) {
    this.viewThisRider = rider;
    this.isRiderInfo = true;
    clearTimeout(this.timeKeeper);
    this.utilService.openModal('riderDetails')
  }
  closeInformation() {
    this.timeKeeper =  setTimeout(() => {
      this.viewThisRider = null;
      this.isRiderInfo = false;
    }, 3000);
  }

  triggerRiderOnboarding(){
    this.utilService.openModal('onboardRider');
  }

  getLocalGvts(){
    this.loadingStates = true;
    this.userService.getlocaleZones().subscribe({
      next: (response)=>{
        this.localGvts = response;
      },
      error: (err)=>{

      }
    }).add(()=> this.loadingStates = false)
  }

  getAllStates(){
    return this.userService.getAllState().subscribe({
      next:((response)=>{
        this.states = response.data;
      })
    })
  }

  onRiderOnboarding(){
   
    if(this.onboardRiderForm.invalid){
      return;
    }
    this.submitting = true;
    const payload = {
      ...this.onboardRiderForm.value, 
      operation_state_id: this.onboardRiderForm.get('state_of_origin_id')?.value,
      operation_lga_id: this.onboardRiderForm.get('lga_of_origin_id')?.value
    }
    this.userService.getRiders(payload).subscribe({
      next: (res)=>{
        this.getRiderProfile();
        this.utilService.closeModal('onboardRider');
      }, error: (err)=>{
      }
    }).add(()=> this.submitting = false);

  }
}

